import { c as _c } from "react/compiler-runtime";
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { formatPrice } from '@winelidays/wld-tsx-2/utils';
const SubTotalDetailLine = (t0) => {
    const $ = _c(22);
    const { subTotal, totalPriceBeforeDiscount } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    let t1;
    if ($[0] !== translate) {
        t1 = translate("availability.calculated_price.sub_total.label");
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const label = t1;
    let t2;
    if ($[2] !== currencySymbol || $[3] !== subTotal || $[4] !== translate) {
        t2 = translate("messages.price_with_currency", { price: formatPrice(subTotal), currencySymbol });
        $[2] = currencySymbol;
        $[3] = subTotal;
        $[4] = translate;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const value = t2;
    let t3;
    if ($[6] !== currencySymbol || $[7] !== subTotal || $[8] !== totalPriceBeforeDiscount || $[9] !== translate) {
        t3 = totalPriceBeforeDiscount !== subTotal ? <>

      <span className="line-through text-gray-500" title={translate("messages.total_price_before_discount")}>

        {`${totalPriceBeforeDiscount}${currencySymbol}`}
      </span> </> : null;
        $[6] = currencySymbol;
        $[7] = subTotal;
        $[8] = totalPriceBeforeDiscount;
        $[9] = translate;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    const totalPriceBeforeDiscountContent = t3;
    let t4;
    if ($[11] !== label) {
        t4 = <span className="text-gray-400">{label}</span>;
        $[11] = label;
        $[12] = t4;
    }
    else {
        t4 = $[12];
    }
    let t5;
    if ($[13] !== label || $[14] !== value) {
        t5 = <span title={label}>{value}</span>;
        $[13] = label;
        $[14] = value;
        $[15] = t5;
    }
    else {
        t5 = $[15];
    }
    let t6;
    if ($[16] !== t5 || $[17] !== totalPriceBeforeDiscountContent) {
        t6 = <span>{totalPriceBeforeDiscountContent}{t5}
    </span>;
        $[16] = t5;
        $[17] = totalPriceBeforeDiscountContent;
        $[18] = t6;
    }
    else {
        t6 = $[18];
    }
    let t7;
    if ($[19] !== t4 || $[20] !== t6) {
        t7 = <div className="flex flex-row justify-between py-1">{t4}{t6}
    </div>;
        $[19] = t4;
        $[20] = t6;
        $[21] = t7;
    }
    else {
        t7 = $[21];
    }
    return t7;
};
export default SubTotalDetailLine;
